const newContactUs =
 {
    fromName: "From Someone",
    toName: "To Someone",
    userName: "studentX",
    subject: "this is the subject of the email",
    message: "sending some message",
    replyTo: "replying to this email address"
};
export default newContactUs;